import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "virtualized-inventory-table-container" }
const _hoisted_2 = ["checked"]
const _hoisted_3 = { class: "table-header__grid" }
const _hoisted_4 = { class: "table-header__data-label" }
const _hoisted_5 = {
  key: 0,
  class: "edit-transaction-control__overlay--row"
}
const _hoisted_6 = { class: "table-cell--bold" }
const _hoisted_7 = { class: "table-row--child" }
const _hoisted_8 = { class: "table-row--error__container" }
const _hoisted_9 = { class: "table-row--error__message" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "table-row--child" }
const _hoisted_12 = {
  key: 0,
  class: "edit-transaction-control__overlay--row"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["value"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["id", "onClick"]
const _hoisted_17 = ["for"]
const _hoisted_18 = {
  key: 0,
  class: "edit-transaction-control__overlay--row"
}

import { computed, ref, toRef, markRaw, defineAsyncComponent, onUnmounted, StyleValue, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { i18n } from '@/i18n';
import { useInventoryStore } from '../../pages/useInventoryStore/';
import { InventoryTableViewModel } from '../../pages/inventoryTableViewModel';
import { DateService } from '@/coreDomainsModule/services/dateService';
import SvgLoader from '@/utils/SvgLoader.vue';
import TextButton from '@/components/input/Btn/TextButton.vue';
import TableMemoButton from '@/corePagesModule/tableMemoButton/TableMemoButton.vue';
import ArrowIcon from '@/corePagesModule/BaseTableContent/components/ArrowIcon.vue';
import {
  MAX_COLUMN_WIDTH,
  MIN_COLUMN_WIDTH,
  DETAIL_BUTTON_COLUMN_WIDTH,
  HEADER_MODIFY_BUTTON_COLUMN_WIDTH,
} from '@/corePagesModule/BaseTableContent/constants';
import { VIRTUAL_SCROLL } from '../../constants/tableConstants';
import { getMonthFromHeaderKey } from '../../utils/tableHelpers';
import { TABLE_CONTENT_ID, HEADER_COLUMN_DEFAULT_NUMBER } from '../../constants';
import { IParentBusiness } from '../../domains/entities/Business';
import { isLoading, isZeroMatch } from '@/coreDomainsModule/uiLoadingState';
import { InventoryTableService } from '../../domains/services/inventoryTableService';
import { LoadingStatus } from '@/corePagesModule/components/ezTable/types';

// 仮想スクロールコンポーネントをインポート
import VirtualizedEzTable from '@/corePagesModule/components/ezTable/VirtualizedEzTable.vue';
import EzHeader from '@/corePagesModule/components/ezTable/EzHeader.vue';
import EzCell from '@/corePagesModule/components/ezTable/EzCell.vue';
import EzTableLoadingState from '@/corePagesModule/components/ezTable/EzTableLoadingState.vue';
import EzTableErrorState from '@/corePagesModule/components/ezTable/EzTableErrorState.vue';
import EzTableZeroMatchState from '@/corePagesModule/components/ezTable/EzTableZeroMatchState.vue';
// 非同期読み込みでバンドルサイズを削減
import { useColumnResizer } from '@/corePagesModule/composables/useColumnResizer';
import { useTableHeader } from '@/corePagesModule/composables/useTableHeader';
import { useTableMemo } from '../../composables/useTableMemo';
import { useTableCalculation } from '@/InventoryControlModule/composables/useTableCalculation';
import { TableCommonViewModel } from '@/viewModels/tableContent';
import TableHeaderModifyButton from '@/corePagesModule/components/TableHeaderModifyButton.vue';
import { useTableState } from '../../composables/useTableState';
import TransactionSummaryColumn from './TransactionSummaryColumn.vue';
import BusinessRowMenu from './BusinessRowMenu.vue';
import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { BusinessFactory } from '@/coreDomainsModule/factories/BusinessFactory';
import { IEditTransactionValue } from '@/InventoryControlModule/pages/useInventoryStore/type';
import { GetHiddenTableHeaderPreferenceUseCase } from '@/InventoryControlModule/useCases/GetHiddenTableHeaderPreferenceUseCase';

/**
 * VirtualizedEzInventoryTableコンポーネントのプロパティ
 * @property {number} tableContainerWidth - テーブルコンテナの幅
 * @property {number} tableContainerHeight - テーブルコンテナの高さ
 * @property {boolean} isEllipsis - テキストが省略されているかどうか
 * @property {Function} mouseoverTextLabel - マウスオーバー時のテキストラベル処理関数
 */
interface VirtualizedEzInventoryTableProps {
  tableContainerWidth: number;
  tableContainerHeight: number;
  isEllipsis: boolean;
  transactionMonths: number[];
  mouseoverTextLabel: (e: MouseEvent) => void;
}

// Props定義
type FullHeader = {
  key: string;
  label: string;
  width: string;
  sticky?: boolean;
  resizable?: boolean;
};

/**
 * パフォーマンス最適化されたデフォルトヘッダーキー（一度だけ計算して固定化）
 * 注意: readonlyを使用せずDataCloneErrorを回避
 */
interface VirtualItem {
  type: 'parent' | 'child' | 'loading' | 'error' | 'zeroMatch';
  data?: IParentBusiness;
  parentId?: string;
}

/**
 * セルがハイライトされているかどうかを判定する
 * @param virtualItem - 仮想アイテム
 * @returns ハイライト状態
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'VirtualizedEzInventoryTable',
  props: {
    tableContainerWidth: {},
    tableContainerHeight: {},
    isEllipsis: { type: Boolean },
    transactionMonths: {},
    mouseoverTextLabel: { type: Function }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "038b7d40": (`${_unref(MAX_COLUMN_WIDTH)}px`),
  "844b0b9c": (`${_unref(MIN_COLUMN_WIDTH)}px`),
  "cb05932c": (`1 / ${_unref(HEADER_COLUMN_DEFAULT_NUMBER) - _unref(getHiddenHeaderNumber)(_unref(state).headerList, _unref(state).headerList) + 1}`),
  "d07fd8e8": (`${tableInnerWidth.value}px`),
  "3967e2e1": (`${_unref(ITEM_HEIGHT)}px`),
  "ffded2bc": (`${_ctx.tableContainerHeight}px`)
}))

const InventoryMonthlyColumn = defineAsyncComponent(() => import('./InventoryMonthlyColumn.vue'));
const props = __props;

// Store
const inventoryStore = useInventoryStore();
const { state } = storeToRefs(inventoryStore);
const {
  toggleOpenBusinesses,
  onCheckedAllRows,
  changeHeaderSorting,
  fetchState,
  fetchChildBusinesses,
  setBusinessRowMenuStateAndProcessing,
  getHiddenTransactionHeader,
} = inventoryStore;
const { checkNearestRecommend, getArrivalStatusWhenDisplayButton, getHiddenHeaderNumber } = useTableCalculation();

// Memo機能のComposable
const { saveAggregateMemo, deleteAggregateMemo, saveChildMemo, deleteChildMemo } = useTableMemo();

// テーブル状態管理のComposable
const { tableTextStyleClass, tableNumberStyleClass, getNowInventoryStatusClass, isNegative } = useTableState();

// i18n
const t = i18n.t;

const vm = markRaw(new TableCommonViewModel());
const inventoryVm = markRaw(new InventoryTableViewModel());

// テーブル要素のrefを宣言（useColumnResizerより前に）
const tableEl = ref<HTMLElement | null>(null);

// 仮想スクロール設定（定数化でcomputed計算を回避）
const ITEM_HEIGHT = VIRTUAL_SCROLL.ITEM_HEIGHT;
const BUFFER_SIZE = VIRTUAL_SCROLL.BUFFER_SIZE;

/**
 * 動的に計算されるコンテナ高さ（propsから取得）
 */
const containerHeight = computed(() => props.tableContainerHeight || 1000);

// 処理負荷軽減のためのキャッシュマップ
const styleClassCache = new Map<string, string>();
const headerDisplayCache = new Map<string, string>();
const executionDateCache = new Map<string, string>();

/**
 * テーブルのヘッダ（チェックボックス列を含む完全版）
 * @property {string} key - ヘッダーのキー
 * @property {string} label - ヘッダーのラベル
 * @property {string} width - 列幅(px)
 * @property {boolean} [sticky] - 固定列かどうか
 */
const defaultFullHeaderKeys = computed(() => {
  const exceptHeaders = new Set(['choice', 'Arrivals', 'orderConfirmation', 'headerModify']);
  const returnHeaders: string[] = [
    'checkbox',
    'orderDetail',
    ...vm.displayHeaders.inventoryControl.filter((key) => !exceptHeaders.has(key)),
  ];

  // 月次データヘッダー（一度だけ計算）
  const monthlyHeaders = props.transactionMonths.flatMap((month) =>
    inventoryVm.getMonthlyTransactionHeaderKeys(month, false).map((arrivalKey) => `transaction-${month}-${arrivalKey}`)
  );

  returnHeaders.push(...monthlyHeaders, 'headerModify');
  return returnHeaders;
});

const { headerList, updateDisplayHeader } = useTableHeader(
  defaultFullHeaderKeys,
  'inventoryControl',
  inventoryVm.DEFAULT_HIDDEN_HEADER_KEYS
);

/**
 * 完全なヘッダー定義を生成する
 * @returns {FullHeader[]} fullHeaders
 */
const fullHeaders = computed(() => {
  const headerListValue = headerList.value;
  const tableInfos = state.value.tableInfos;

  // 基本ヘッダー定義を最初に作成
  const returnHeaders: FullHeader[] = [
    {
      key: 'checkbox',
      label: '',
      width: '50px',
      sticky: true,
      resizable: false,
    },
    {
      key: 'orderDetail',
      label: t('詳細'),
      width: `${DETAIL_BUTTON_COLUMN_WIDTH}px`,
      sticky: true,
      resizable: false,
    },
  ];

  const exceptHeaderSet = new Set(['choice', 'Arrivals', 'orderConfirmation', 'headerModify']);
  const baseHeaders = vm.displayHeaders.inventoryControl.filter((key) => !exceptHeaderSet.has(key) && headerListValue.includes(key));

  // 基本ヘッダーを追加（ヘッダー名のキャッシュ活用）
  for (const header of baseHeaders) {
    let label = headerDisplayCache.get(header);
    if (!label) {
      label = inventoryVm.getDisplayHeaderName(header);
      if (label) headerDisplayCache.set(header, label);
    }
    if (!label) continue;

    returnHeaders.push({
      key: header,
      label: t(label),
      width: `${tableInfos[header] || MIN_COLUMN_WIDTH}px`,
      sticky: true,
      resizable: true,
    });
  }

  // 月次データヘッダー（事前計算された配列を利用）
  const transactionMonths = props.transactionMonths;
  for (let i = 0; i < transactionMonths.length; i++) {
    const month = transactionMonths[i];
    const monthlyKeys = inventoryVm.getMonthlyTransactionHeaderKeys(month, false);

    for (let j = 0; j < monthlyKeys.length; j++) {
      const arrivalKey = monthlyKeys[j];
      const key = `transaction-${month}-${arrivalKey}`;

      if (!headerListValue.includes(key)) continue;

      const labelMonth = arrivalKey !== 'nowInventory' ? t(DateService.getFormattedMonth(month)) + '\n' : '';

      returnHeaders.push({
        key,
        label: `${labelMonth}${inventoryVm.getTransactionHeaderName(arrivalKey)}`,
        width: `${tableInfos[key] || MIN_COLUMN_WIDTH}px`,
        resizable: arrivalKey !== 'alert',
      });
    }
  }

  // ヘッダー追加列
  returnHeaders.push({
    key: 'headerModify',
    label: t('ヘッダー追加'),
    width: `${HEADER_MODIFY_BUTTON_COLUMN_WIDTH}px`,
    sticky: false,
    resizable: false,
  });

  return returnHeaders;
});

const getModifiableHeaderList = computed(() => {
  const headerListValue = headerList.value;
  const excludedKeys = new Set(['checkbox', 'orderDetail', 'headerModify']);
  const inventoryControlHeaders = new Set(vm.displayHeaders.inventoryControl);

  return defaultFullHeaderKeys.value
    .filter((key) => !excludedKeys.has(key))
    .map((key) => {
      if (inventoryControlHeaders.has(key)) {
        let text = headerDisplayCache.get(key);
        if (!text) {
          text = inventoryVm.getDisplayHeaderName(key);
          headerDisplayCache.set(key, text);
        }
        return { key, text, isShown: headerListValue.includes(key) };
      }

      const splitKey = key.split('-');
      const arrivalKey = splitKey.at(-1);
      const arrivalMonth = getMonthFromHeaderKey(key);

      if (!splitKey || !arrivalKey) {
        return { key, text: 'ERROR', isShown: headerListValue.includes(key) };
      }

      const labelText = inventoryVm.getTransactionHeaderName(arrivalKey);
      const labelMonth = arrivalKey !== 'nowInventory' ? t(DateService.getFormattedMonth(arrivalMonth)) + '\n' : '';

      return {
        key,
        text: `${labelMonth}${labelText}`,
        isShown: headerListValue.includes(key),
      };
    });
});

/**
 * 固定する列のインデックス配列を生成する
 * @returns {number[]} stickyColumnIndexes
 */
const stickyColumnIndexes = computed(() => {
  const indexes: number[] = [];
  const headers = fullHeaders.value;

  for (let i = 0; i < headers.length; i++) {
    if (headers[i].sticky) {
      indexes.push(i);
    }
  }
  return indexes;
});

/**
 * ヘッダー配列の最適化されたバージョン
 */
const headersDisplay = computed(() => {
  const headers = fullHeaders.value;
  return headers.slice(1); // チェックボックス列を除く
});

/**
 * Setで最適化されたヘッダーソート判定（一度計算してキャッシュ）
 */
const sortableHeaders = computed(() => {
  const sortable = new Set<string>();
  const headers = headersDisplay.value;

  for (let i = 0; i < headers.length; i++) {
    const header = headers[i];
    if (InventoryTableService.isHeaderKeySortable(header.key)) {
      sortable.add(header.key);
    }
  }
  return sortable;
});

/**
 * 最適化されたヘッダーに対する粘着オフセット（前方累積和で計算）
 */
const stickyOffsets = computed(() => {
  const offsets = new Map<string, number>();
  const headers = fullHeaders.value;
  let offset = 0;

  for (let i = 0; i < headers.length; i++) {
    const header = headers[i];
    if (header.sticky) {
      offsets.set(header.key, offset);
      offset += parseFloat(header.width) || 0;
    }
  }

  return offsets;
});

/**
 * グリッドテンプレート列の配列を生成する（mapの代わりに直接配列構築）
 */
const gridTemplateColumns = computed(() => {
  const headers = fullHeaders.value;
  const columns: string[] = new Array(headers.length);

  for (let i = 0; i < headers.length; i++) {
    columns[i] = headers[i].width;
  }
  return columns;
});

const tableInnerWidth = computed(() => {
  const headers = fullHeaders.value;
  let res = 0;
  for (let i = 0; i < headers.length; i++) {
    res += parseInt(headers[i].width);
  }
  return res;
});

/**
 * 展開されたアイテムのセット
 */
const expandedItems = computed(() => {
  const expanded = new Set<string>();
  if (state.value.isOpeningBusinessId) {
    expanded.add(state.value.isOpeningBusinessId);
  }
  return expanded;
});

/**
 * 子アイテムを取得する関数
 * @param item - 親ビジネスアイテム
 * @returns 子アイテムの配列
 */
const getChildItems = (item: IParentBusiness) => {
  return item.children || [];
};

/**
 * 仮想スクロールの展開/折りたたみハンドラ
 * @param itemId - トグル対象のアイテムID
 * @returns Promise
 */
const handleToggle = async (itemId: string) => {
  await toggleOpenBusinesses(itemId);
};

/**
 * 仮想スクロールのアイテムクリックハンドラ
 */
const handleItemClick = () => {
  // 必要に応じてクリック処理を実装
};

/**
 * 仮想スクロールのスクロールハンドラ
 */
const handleScroll = () => {
  // スクロールイベントの処理（必要に応じて拡張）
  state.value.isOpeningAlertBusinessId = '';
};

/**
 * 横方向スクロールハンドラ
 */
const handleHorizontalScroll = () => {
  state.value.isOpeningAlertBusinessId = '';
};

/**
 * 現在のテーブルローディング状態をEzTable用の型に変換
 */
const currentLoadingStatus = computed((): LoadingStatus => {
  const tableStatus = state.value.tableLoadingState.status;

  if (isLoading(tableStatus) || headerList.value.length === 0) {
    return { type: 'loading' };
  }

  if (tableStatus.type === 'error') {
    return {
      type: 'error',
      errorMessage: tableStatus.errorMessage || t('データの取得に失敗しました。再度お試しください。'),
    };
  }

  if (isZeroMatch(tableStatus) && state.value.businessList.length === 0) {
    return { type: 'zero-match' };
  }

  return { type: 'success' };
});

/**
 * エラー状態での再試行ハンドラ
 */
const handleRetry = () => {
  fetchState();
};

/**
 * YYYY/MM/DD形式のexecutionDateの文字列を取得する（キャッシュ付き）
 * @param business - 取引情報
 */
const getExecutionDateFormatted = (business: IParentBusiness) => {
  const businessId = business.businessId;
  let formatted = executionDateCache.get(businessId);

  if (formatted === undefined) {
    formatted =
      business.executionDate !== undefined
        ? DateService.convertIYearMonthDayToYYYYMMDDWithi18n(DateService.convertDateToIDate(business.executionDate))
        : '';
    executionDateCache.set(businessId, formatted);
  }

  return formatted;
};

/** executionDateのcacheを明示的に更新する */
watch(
  () => state.value.businessRowMenuState.editTransaction.isEditTransactionMode,
  (newValue, oldValue) => {
    if (!newValue && oldValue) {
      executionDateCache.clear();
    }
  }
);

/**
 * 月別の最後のヘッダーキー
 */
const getMonthlyEndHeader = computed(() => {
  return props.transactionMonths.reduce((acc, month) => {
    acc[month] = inventoryVm
      .getMonthlyTransactionHeaderKeys(month, false)
      .filter((key) => !state.value.hiddenTransactionHeaderList.includes(`transaction-${month}-${key}`))
      .at(-1);
    return acc;
  }, {});
});

/**
 * ヘッダーキーがある月の最後のヘッダーと一致しているか(=ヘッダーの右にボーダーが出るか)を返す関数
 * @param headerKey - ヘッダーキー
 */
const borderHeadersSet = computed(() => {
  const borderHeaders = new Set<string>();
  const monthlyEndHeaders = getMonthlyEndHeader.value;

  props.transactionMonths.forEach((month) => {
    const endHeader = monthlyEndHeaders[month];
    if (endHeader) {
      borderHeaders.add(`transaction-${month}-${endHeader}`);
    }
  });

  return borderHeaders;
});

/**
 *　　ヘッダーキーがボーダーの右側にあるかどうかを判定する関数
 * @param headerKey - ヘッダーキー
 */
const hasHeaderRightBorder = (headerKey: string) => borderHeadersSet.value.has(headerKey);

const { onMousedownResizer } = useColumnResizer({
  tableType: 'inventoryControl',
  keys: fullHeaders.value.map((header) => header.key),
  widthInfo: toRef(state.value, 'tableInfos'),
  tableEl, // テーブル要素のrefを渡す
});

/**
 * 子取引をリロードする(エラー時)
 * @param id - 親取引ID
 */
const reloadChildBusiness = async (id?: string) => {
  if (!id) return;
  await fetchChildBusinesses(id);
};

/**
 * 仮想アイテムの型定義
 */
const isCellHighlighted = (virtualItem: VirtualItem): boolean => {
  const openingBusinessId = state.value.isOpeningBusinessId;
  const checkedBusinessIds = state.value.checkedAggregateBusinessIds;

  // 早期リターンで計算量を削減
  // 子取引行またはロード行は常にハイライト
  if (virtualItem.type === 'child' || virtualItem.type === 'loading') {
    return true;
  }

  // データが存在しない場合はハイライトしない
  if (!virtualItem.data) {
    return false;
  }

  const itemData = virtualItem.data;

  // チェックボックスが選択されている親取引
  if (checkedBusinessIds.includes(itemData.businessId)) {
    return true;
  }

  // チェックボックスが選択されている子取引（parentIdで判定）
  if (virtualItem.parentId && checkedBusinessIds.includes(virtualItem.parentId)) {
    return true;
  }

  // 展開中の親取引
  if (
    openingBusinessId === itemData.businessId &&
    (itemData.childrenAsyncStatus === 'loading' || itemData.childrenAsyncStatus === 'loaded')
  ) {
    return true;
  }

  return false;
};

/**
 * 固定する列のleft値を算出する（前計算版）
 */
const calcLeftNumber = computed(() => {
  const headers = fullHeaders.value;
  const leftPositions = new Map<number, number>();

  // 前計算で全てのポジションを算出
  let accumulatedLeft = 0;
  for (let i = 0; i < headers.length; i++) {
    if (headers[i].sticky) {
      leftPositions.set(i, accumulatedLeft);
      accumulatedLeft += parseFloat(headers[i].width) || 0;
    } else {
      leftPositions.set(i, 0);
    }
  }

  return (headerIndex: number) => leftPositions.get(headerIndex) || 0;
});

/**
 * 数値編集の値を更新する関数
 * @param value - 数値編集の値
 */
const updateEditTransactionValue = (value: IEditTransactionValue): void => {
  const isValueExists = state.value.businessRowMenuState.editTransaction.changedValue.some(
    (v) => v.month === value.month && v.type === value.type && (value.baseBusinessId ? v.baseBusinessId === value.baseBusinessId : true)
  );
  if (!isValueExists) {
    state.value.businessRowMenuState.editTransaction.changedValue.push(value);
  } else {
    const newChangedValue = state.value.businessRowMenuState.editTransaction.changedValue.map((v) =>
      v.type === value.type && v.month === value.month && (value.baseBusinessId ? v.baseBusinessId === value.baseBusinessId : true)
        ? value
        : v
    );
    state.value.businessRowMenuState.editTransaction.changedValue = newChangedValue;
  }
};

const tableHeaderHeight = computed(() => {
  const tableHeaderContainer = document.getElementsByClassName('table__header-container')[0];
  return tableHeaderContainer && tableHeaderContainer.clientHeight;
});

const editTransactionModeStyle = computed(() => {
  return state.value.businessRowMenuState.editTransaction.isEditTransactionMode
    ? { NOT_ALLOW_CURSOR: 'not-allow-cursor', DISABLED_EVENT: 'disabled-event', BOTH: 'not-allow-cursor disabled-event' }
    : undefined;
});

const tableOverlayTop = computed(
  (): StyleValue => ({
    top: `${
      (tableHeaderHeight.value ?? 0) +
      ITEM_HEIGHT *
        (1 +
          state.value.businessList.length +
          (state.value.businessList.find((b) => state.value.isOpeningBusinessId === b.businessId)?.children.length ?? 0))
    }px`,
  })
);

/**
 * ヘッダーの表示状態を更新する関数
 * ヘッダーの表示状態を更新し、state.value.hiddenTransactionHeaderListを更新する
 * @param key - ヘッダーキー
 * @param isHide - ヘッダーを非表示にするかどうか
 */
const updateTableHeaderData = async (key: string, isHide: boolean): Promise<void> => {
  // ヘッダーの表示状態を更新
  await updateDisplayHeader(key, isHide);
  // 非表示のトランザクションヘッダーリストを更新
  await getHiddenTransactionHeader();
};

/**
 * 言語設定が変更された際にヘッダーのキャッシュをリセットする
 */
watch(
  () => i18n.locale,
  () => {
    headerDisplayCache.clear();
  }
);

/**
 * コンポーネントのクリーンアップ処理
 * メモリリークを防ぐためにキャッシュをクリア
 */
onUnmounted(() => {
  styleClassCache.clear();
  headerDisplayCache.clear();
  executionDateCache.clear();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(VirtualizedEzTable, {
      id: _unref(TABLE_CONTENT_ID),
      ref_key: "tableEl",
      ref: tableEl,
      items: _unref(state).businessList,
      "item-height": _unref(ITEM_HEIGHT),
      "container-height": containerHeight.value,
      "buffer-size": _unref(BUFFER_SIZE),
      "grid-template-columns": gridTemplateColumns.value,
      "expanded-items": expandedItems.value,
      "get-child-items": getChildItems,
      "loading-status": currentLoadingStatus.value,
      "sticky-column-indexes": stickyColumnIndexes.value,
      class: "inventory-virtual-table",
      onToggle: handleToggle,
      onItemClick: handleItemClick,
      onHorizontalScroll: handleHorizontalScroll,
      onScroll: handleScroll,
      onRetry: handleRetry
    }, {
      header: _withCtx(() => [
        _createVNode(EzHeader, {
          sticky: "",
          "sticky-offset": 0,
          class: _normalizeClass(editTransactionModeStyle.value?.NOT_ALLOW_CURSOR)
        }, {
          default: _withCtx(() => [
            _createElementVNode("input", {
              class: _normalizeClass(editTransactionModeStyle.value?.DISABLED_EVENT),
              type: "checkbox",
              checked: _unref(state).isCheckAllRows,
              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onCheckedAllRows) && _unref(onCheckedAllRows)(...args)))
            }, null, 42, _hoisted_2)
          ], undefined, true),
          _: 1
        }, 8, ["class"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headersDisplay.value, (header) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: header.key
          }, [
            (header.key !== 'headerModify')
              ? (_openBlock(), _createBlock(EzHeader, {
                  key: 0,
                  "has-right-border": hasHeaderRightBorder(header.key),
                  sticky: header.sticky,
                  "sticky-offset": stickyOffsets.value.get(header.key) || 0,
                  "use-resizer": header.resizable,
                  class: "table-header__data",
                  onClick: ($event: any) => (_unref(changeHeaderSorting)(header.key)),
                  onResizer: 
              (e) => {
                _unref(onMousedownResizer)(e, header.key);
              }
            
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("span", _hoisted_4, _toDisplayString(header.label), 1),
                      (sortableHeaders.value.has(header.key))
                        ? (_openBlock(), _createBlock(ArrowIcon, {
                            key: 0,
                            asc: header.key === _unref(state).headerSortingState.key ? _unref(state).headerSortingState.isAsc : true,
                            onOnClick: ($event: any) => (_unref(changeHeaderSorting)(header.key))
                          }, null, 8, ["asc", "onOnClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ], undefined, true),
                  _: 2
                }, 1032, ["has-right-border", "sticky", "sticky-offset", "use-resizer", "onClick", "onResizer"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128)),
        _createVNode(EzHeader, { sticky: "right" }, {
          default: _withCtx(() => [
            _createVNode(TableHeaderModifyButton, {
              "modifiable-header-list": getModifiableHeaderList.value,
              disabled: _unref(state).businessRowMenuState.editTransaction.isEditTransactionMode,
              "tool-tip-message": 
              _unref(state).businessRowMenuState.editTransaction.isEditTransactionMode ? _unref(t)('数値データ編集中は使用できません') : undefined
            ,
              onToggle: updateTableHeaderData
            }, null, 8, ["modifiable-header-list", "disabled", "tool-tip-message"])
          ], undefined, true),
          _: 1
        })
      ]),
      "body-root": _withCtx(() => [
        (
            _unref(state).businessRowMenuState.editTransaction.isEditTransactionMode &&
            _unref(ITEM_HEIGHT) * _unref(state).businessList.length < _ctx.tableContainerHeight
          )
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "edit-transaction-control__overlay--table",
              style: _normalizeStyle(tableOverlayTop.value)
            }, null, 4))
          : _createCommentVNode("", true)
      ]),
      "row-top-sticky": _withCtx(() => [
        (_unref(state).businessRowMenuState.editTransaction.isEditTransactionMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5))
          : _createCommentVNode("", true),
        _createVNode(EzCell, {
          style: _normalizeStyle({ gridColumn: `1 / ${_unref(headerList).filter((header) => _unref(vm).displayHeaders.inventoryControl.includes(header)).length + 2}` }),
          class: "table-cell--totalization table-cell--totalization--sticky"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('合計（取引{number}件全ての数値の合計）', { number: String(_unref(state).pagingOptions.totalResultsAvailable) })), 1)
          ], undefined, true),
          _: 1
        }, 8, ["style"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.transactionMonths, (month) => {
          return (_openBlock(), _createBlock(TransactionSummaryColumn, {
            key: month,
            month: month,
            data: _unref(state).summaryData,
            "header-list": _unref(headerList),
            "inventory-vm": _unref(inventoryVm),
            "monthly-end-header": getMonthlyEndHeader.value[month]
          }, null, 8, ["month", "data", "header-list", "inventory-vm", "monthly-end-header"]))
        }), 128)),
        _createVNode(EzCell, { class: "table-cell--totalization" })
      ]),
      "row-sticky": _withCtx(({ item, virtualItem, handleToggle: rowHandleToggle }) => [
        (virtualItem.type === 'loading')
          ? (_openBlock(), _createBlock(EzCell, {
              key: 0,
              "is-highlighted": "",
              style: { gridColumn: '1 / -1' }
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('ローディング中...')), 1)
              ], undefined, true),
              _: 1
            }))
          : (virtualItem.type === 'error')
            ? (_openBlock(), _createBlock(EzCell, {
                key: 1,
                class: "table-row--error",
                style: { gridColumn: '1 / -1' }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('子情報の取得に失敗しました。再度お試しください。')), 1),
                    _createElementVNode("div", {
                      class: "table-row--error__button",
                      onClick: ($event: any) => (reloadChildBusiness(virtualItem.parentId))
                    }, _toDisplayString(_unref(t)('再取得')), 9, _hoisted_10)
                  ])
                ], undefined, true),
                _: 2
              }, 1024))
            : (virtualItem.type === 'zeroMatch')
              ? (_openBlock(), _createBlock(EzCell, {
                  key: 2,
                  "is-highlighted": "",
                  style: { gridColumn: '1 / -1' }
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('子取引がありません。')), 1)
                  ], undefined, true),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  (
              _unref(state).businessRowMenuState.editTransaction.isEditTransactionMode &&
              !(virtualItem.id == _unref(state).isOpeningBusinessId || virtualItem.parentId == _unref(state).isOpeningBusinessId)
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12))
                    : _createCommentVNode("", true),
                  _createVNode(EzCell, {
                    "is-highlighted": isCellHighlighted(virtualItem)
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["grid-container table-checkbox", editTransactionModeStyle.value?.NOT_ALLOW_CURSOR])
                      }, [
                        (virtualItem.type === 'parent')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).checkedAggregateBusinessIds) = $event)),
                                class: _normalizeClass(editTransactionModeStyle.value?.DISABLED_EVENT),
                                type: "checkbox",
                                value: item.businessId
                              }, null, 10, _hoisted_14), [
                                [_vModelCheckbox, _unref(state).checkedAggregateBusinessIds]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (virtualItem.type === 'parent')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createElementVNode("input", {
                                id: item.businessId,
                                class: _normalizeClass(["table-toggle", editTransactionModeStyle.value?.DISABLED_EVENT]),
                                type: "checkbox",
                                onClick: ($event: any) => (rowHandleToggle(item.businessId))
                              }, null, 10, _hoisted_16),
                              _createElementVNode("label", {
                                for: item.businessId,
                                class: _normalizeClass(["table-toggle__label", editTransactionModeStyle.value?.BOTH])
                              }, [
                                (_unref(state).isOpeningBusinessId !== item.businessId)
                                  ? (_openBlock(), _createBlock(SvgLoader, {
                                      key: 0,
                                      class: "table-toggle__label--closed",
                                      name: "chevronRight"
                                    }))
                                  : (_openBlock(), _createBlock(SvgLoader, {
                                      key: 1,
                                      class: "table-toggle__label--opened",
                                      name: "chevronRight"
                                    }))
                              ], 10, _hoisted_17)
                            ]))
                          : _createCommentVNode("", true)
                      ], 2)
                    ], undefined, true),
                    _: 2
                  }, 1032, ["is-highlighted"]),
                  _createVNode(EzCell, {
                    class: "table-cell__content--detail",
                    "is-highlighted": isCellHighlighted(virtualItem)
                  }, {
                    default: _withCtx(() => [
                      (virtualItem.type === 'parent')
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: { name: 'recommend-order', params: { id: item.businessId } },
                            target: "_blank"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(TextButton, {
                                class: "table-button table-button--detail",
                                "button-style": "btn-secondary",
                                "on-click": () => {}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('詳細')), 1)
                                ], undefined, true),
                                _: 1
                              })
                            ], undefined, true),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true)
                    ], undefined, true),
                    _: 2
                  }, 1032, ["is-highlighted"]),
                  (_unref(headerList).includes('warehouseNumber'))
                    ? (_openBlock(), _createBlock(EzCell, {
                        key: 1,
                        "is-highlighted": isCellHighlighted(virtualItem),
                        class: _normalizeClass(virtualItem.type === 'child' ? 'table-child-item' : _unref(tableTextStyleClass)(item, _unref(state).isOpeningBusinessId, 'virtualized'))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(virtualItem.type === 'parent' ? item.warehouseNumber ?? '--' : ''), 1)
                        ], undefined, true),
                        _: 2
                      }, 1032, ["is-highlighted", "class"]))
                    : _createCommentVNode("", true),
                  (_unref(headerList).includes('warehouse'))
                    ? (_openBlock(), _createBlock(EzCell, {
                        key: 2,
                        "is-highlighted": isCellHighlighted(virtualItem),
                        class: _normalizeClass(virtualItem.type === 'child' ? 'table-child-item' : _unref(tableTextStyleClass)(item, _unref(state).isOpeningBusinessId, 'virtualized'))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(virtualItem.type === 'parent' ? item.warehouse ?? '--' : ''), 1)
                        ], undefined, true),
                        _: 2
                      }, 1032, ["is-highlighted", "class"]))
                    : _createCommentVNode("", true),
                  (_unref(headerList).includes('supplierNumber'))
                    ? (_openBlock(), _createBlock(EzCell, {
                        key: 3,
                        "is-highlighted": isCellHighlighted(virtualItem),
                        class: _normalizeClass(virtualItem.type === 'child' ? 'table-child-item' : _unref(tableTextStyleClass)(item, _unref(state).isOpeningBusinessId, 'virtualized'))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(virtualItem.type === 'parent' ? item.supplierNumber ?? '--' : ''), 1)
                        ], undefined, true),
                        _: 2
                      }, 1032, ["is-highlighted", "class"]))
                    : _createCommentVNode("", true),
                  (_unref(headerList).includes('supplier'))
                    ? (_openBlock(), _createBlock(EzCell, {
                        key: 4,
                        "is-highlighted": isCellHighlighted(virtualItem),
                        class: _normalizeClass(virtualItem.type === 'child' ? 'table-child-item' : _unref(tableTextStyleClass)(item, _unref(state).isOpeningBusinessId, 'virtualized'))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(virtualItem.type === 'parent' ? item.supplierName ?? '--' : ''), 1)
                        ], undefined, true),
                        _: 2
                      }, 1032, ["is-highlighted", "class"]))
                    : _createCommentVNode("", true),
                  (_unref(headerList).includes('businessNumber'))
                    ? (_openBlock(), _createBlock(EzCell, {
                        key: 5,
                        "is-highlighted": isCellHighlighted(virtualItem),
                        class: _normalizeClass(virtualItem.type === 'child' ? 'table-child-item' : _unref(tableTextStyleClass)(item, _unref(state).isOpeningBusinessId, 'virtualized'))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(virtualItem.type === 'parent' ? item.businessNumber ?? '--' : ''), 1)
                        ], undefined, true),
                        _: 2
                      }, 1032, ["is-highlighted", "class"]))
                    : _createCommentVNode("", true),
                  (_unref(headerList).includes('businessName'))
                    ? (_openBlock(), _createBlock(EzCell, {
                        key: 6,
                        "is-highlighted": isCellHighlighted(virtualItem),
                        class: _normalizeClass(virtualItem.type === 'child' ? 'table-child-item' : _unref(tableTextStyleClass)(item, _unref(state).isOpeningBusinessId, 'virtualized'))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(virtualItem.type === 'parent' ? item.businessName ?? '--' : ''), 1)
                        ], undefined, true),
                        _: 2
                      }, 1032, ["is-highlighted", "class"]))
                    : _createCommentVNode("", true),
                  (_unref(headerList).includes('package'))
                    ? (_openBlock(), _createBlock(EzCell, {
                        key: 7,
                        "is-number": true,
                        "is-highlighted": isCellHighlighted(virtualItem),
                        class: _normalizeClass(
              virtualItem.type === 'child'
                ? 'table-child-item table-cell--number'
                : _unref(tableNumberStyleClass)(item, _unref(state).isOpeningBusinessId, 'virtualized')
            )
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(virtualItem.type === 'parent' ? item.package ?? '--' : ''), 1)
                        ], undefined, true),
                        _: 2
                      }, 1032, ["is-highlighted", "class"]))
                    : _createCommentVNode("", true),
                  (_unref(headerList).includes('unit'))
                    ? (_openBlock(), _createBlock(EzCell, {
                        key: 8,
                        "is-highlighted": isCellHighlighted(virtualItem),
                        class: _normalizeClass(virtualItem.type === 'child' ? 'table-child-item' : _unref(tableTextStyleClass)(item, _unref(state).isOpeningBusinessId, 'virtualized'))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(virtualItem.type === 'parent' ? item.unit ?? '--' : ''), 1)
                        ], undefined, true),
                        _: 2
                      }, 1032, ["is-highlighted", "class"]))
                    : _createCommentVNode("", true),
                  (_unref(headerList).includes('customerNumber'))
                    ? (_openBlock(), _createBlock(EzCell, {
                        key: 9,
                        "is-highlighted": isCellHighlighted(virtualItem),
                        class: _normalizeClass(virtualItem.type === 'child' ? 'table-child-item' : _unref(tableTextStyleClass)(item, _unref(state).isOpeningBusinessId, 'virtualized'))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.customerNumber ?? '--'), 1)
                        ], undefined, true),
                        _: 2
                      }, 1032, ["is-highlighted", "class"]))
                    : _createCommentVNode("", true),
                  (_unref(headerList).includes('customerName'))
                    ? (_openBlock(), _createBlock(EzCell, {
                        key: 10,
                        "is-highlighted": isCellHighlighted(virtualItem),
                        class: _normalizeClass(virtualItem.type === 'child' ? 'table-child-item' : _unref(tableTextStyleClass)(item, _unref(state).isOpeningBusinessId, 'virtualized'))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.customerName ?? '--'), 1)
                        ], undefined, true),
                        _: 2
                      }, 1032, ["is-highlighted", "class"]))
                    : _createCommentVNode("", true),
                  (_unref(headerList).includes('salesDestinationNumber'))
                    ? (_openBlock(), _createBlock(EzCell, {
                        key: 11,
                        "is-highlighted": isCellHighlighted(virtualItem),
                        class: _normalizeClass(virtualItem.type === 'child' ? 'table-child-item' : _unref(tableTextStyleClass)(item, _unref(state).isOpeningBusinessId, 'virtualized'))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.salesDestinationNumber ?? '--'), 1)
                        ], undefined, true),
                        _: 2
                      }, 1032, ["is-highlighted", "class"]))
                    : _createCommentVNode("", true),
                  (_unref(headerList).includes('salesDestinationName'))
                    ? (_openBlock(), _createBlock(EzCell, {
                        key: 12,
                        "is-highlighted": isCellHighlighted(virtualItem),
                        class: _normalizeClass(virtualItem.type === 'child' ? 'table-child-item' : _unref(tableTextStyleClass)(item, _unref(state).isOpeningBusinessId, 'virtualized'))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.salesDestinationName ?? '--'), 1)
                        ], undefined, true),
                        _: 2
                      }, 1032, ["is-highlighted", "class"]))
                    : _createCommentVNode("", true),
                  (_unref(headerList).includes('forecastForReceiptName'))
                    ? (_openBlock(), _createBlock(EzCell, {
                        key: 13,
                        "is-highlighted": isCellHighlighted(virtualItem),
                        class: _normalizeClass(virtualItem.type === 'child' ? 'table-child-item' : _unref(tableTextStyleClass)(item, _unref(state).isOpeningBusinessId, 'virtualized'))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(virtualItem.type === 'parent' ? '--' : item.forecastForReceiptName ?? '--'), 1)
                        ], undefined, true),
                        _: 2
                      }, 1032, ["is-highlighted", "class"]))
                    : _createCommentVNode("", true),
                  (_unref(headerList).includes('manufacturer'))
                    ? (_openBlock(), _createBlock(EzCell, {
                        key: 14,
                        "is-highlighted": isCellHighlighted(virtualItem),
                        class: _normalizeClass(virtualItem.type === 'child' ? 'table-child-item' : _unref(tableTextStyleClass)(item, _unref(state).isOpeningBusinessId, 'virtualized'))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(virtualItem.type === 'parent' ? item.manufacturer ?? '--' : ''), 1)
                        ], undefined, true),
                        _: 2
                      }, 1032, ["is-highlighted", "class"]))
                    : _createCommentVNode("", true),
                  (_unref(headerList).includes('endUser'))
                    ? (_openBlock(), _createBlock(EzCell, {
                        key: 15,
                        "is-highlighted": isCellHighlighted(virtualItem),
                        class: _normalizeClass(virtualItem.type === 'child' ? 'table-child-item' : _unref(tableTextStyleClass)(item, _unref(state).isOpeningBusinessId, 'virtualized'))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.endUser ?? '--'), 1)
                        ], undefined, true),
                        _: 2
                      }, 1032, ["is-highlighted", "class"]))
                    : _createCommentVNode("", true),
                  (_unref(headerList).includes('leadTime'))
                    ? (_openBlock(), _createBlock(EzCell, {
                        key: 16,
                        "is-highlighted": isCellHighlighted(virtualItem),
                        class: _normalizeClass(virtualItem.type === 'child' ? 'table-child-item' : _unref(tableTextStyleClass)(item, _unref(state).isOpeningBusinessId, 'virtualized'))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(virtualItem.type === 'parent' ? _unref(inventoryVm).getFormattedLeadTime(item.leadTime, item.leadTimeUnit) ?? '--' : ''), 1)
                        ], undefined, true),
                        _: 2
                      }, 1032, ["is-highlighted", "class"]))
                    : _createCommentVNode("", true),
                  (_unref(headerList).includes('stdInventoryIndex'))
                    ? (_openBlock(), _createBlock(EzCell, {
                        key: 17,
                        "is-highlighted": isCellHighlighted(virtualItem),
                        class: _normalizeClass(virtualItem.type === 'child' ? 'table-child-item' : _unref(tableTextStyleClass)(item, _unref(state).isOpeningBusinessId, 'virtualized'))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(virtualItem.type === 'parent' ? _unref(inventoryVm).getFormattedStdInventoryIndex(item.stdInventoryIndices) ?? '--' : ''), 1)
                        ], undefined, true),
                        _: 2
                      }, 1032, ["is-highlighted", "class"]))
                    : _createCommentVNode("", true),
                  (_unref(headerList).includes('MOQ'))
                    ? (_openBlock(), _createBlock(EzCell, {
                        key: 18,
                        "is-highlighted": isCellHighlighted(virtualItem),
                        "is-number": true,
                        class: _normalizeClass(
              virtualItem.type === 'child'
                ? 'table-child-item table-cell--number'
                : _unref(tableNumberStyleClass)(item, _unref(state).isOpeningBusinessId, 'virtualized')
            )
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(virtualItem.type === 'parent' ? item.MOQ ?? '--' : ''), 1)
                        ], undefined, true),
                        _: 2
                      }, 1032, ["is-highlighted", "class"]))
                    : _createCommentVNode("", true),
                  (_unref(headerList).includes('orderPackage'))
                    ? (_openBlock(), _createBlock(EzCell, {
                        key: 19,
                        "is-highlighted": isCellHighlighted(virtualItem),
                        "is-number": true,
                        class: _normalizeClass(
              virtualItem.type === 'child'
                ? 'table-child-item table-cell--number'
                : _unref(tableNumberStyleClass)(item, _unref(state).isOpeningBusinessId, 'virtualized')
            )
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(virtualItem.type === 'parent' && item.orderPackage ? item.orderPackage : '--'), 1)
                        ], undefined, true),
                        _: 2
                      }, 1032, ["is-highlighted", "class"]))
                    : _createCommentVNode("", true),
                  (_unref(headerList).includes('supplierForecastResponsibleUser'))
                    ? (_openBlock(), _createBlock(EzCell, {
                        key: 20,
                        "is-highlighted": isCellHighlighted(virtualItem),
                        class: _normalizeClass(virtualItem.type === 'child' ? 'table-child-item' : _unref(tableTextStyleClass)(item, _unref(state).isOpeningBusinessId, 'virtualized'))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(virtualItem.type === 'parent' ? _unref(inventoryVm).getUserNames(item.aggregateBusinessResponsibleUsers) : ''), 1)
                        ], undefined, true),
                        _: 2
                      }, 1032, ["is-highlighted", "class"]))
                    : _createCommentVNode("", true),
                  (_unref(headerList).includes('customerForecastResponsibleUser'))
                    ? (_openBlock(), _createBlock(EzCell, {
                        key: 21,
                        "is-highlighted": isCellHighlighted(virtualItem),
                        class: _normalizeClass(virtualItem.type === 'child' ? 'table-child-item' : _unref(tableTextStyleClass)(item, _unref(state).isOpeningBusinessId, 'virtualized'))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(inventoryVm).getUserNames(item.baseBusinessResponsibleUsers)), 1)
                        ], undefined, true),
                        _: 2
                      }, 1032, ["is-highlighted", "class"]))
                    : _createCommentVNode("", true),
                  (_unref(headerList).includes('updatedAt'))
                    ? (_openBlock(), _createBlock(EzCell, {
                        key: 22,
                        "is-highlighted": isCellHighlighted(virtualItem),
                        class: _normalizeClass(virtualItem.type === 'child' ? 'table-child-item' : _unref(tableTextStyleClass)(item, _unref(state).isOpeningBusinessId, 'virtualized'))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.updatedAt ? _unref(DateService).getDisplayYearMonthDay(new Date(item.updatedAt * 1000)) : '--'), 1)
                        ], undefined, true),
                        _: 2
                      }, 1032, ["is-highlighted", "class"]))
                    : _createCommentVNode("", true),
                  (_unref(headerList).includes('createdAt'))
                    ? (_openBlock(), _createBlock(EzCell, {
                        key: 23,
                        "is-highlighted": isCellHighlighted(virtualItem),
                        class: _normalizeClass(virtualItem.type === 'child' ? 'table-child-item' : _unref(tableTextStyleClass)(item, _unref(state).isOpeningBusinessId, 'virtualized'))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.createdAt ? _unref(DateService).getDisplayYearMonthDay(new Date(item.createdAt * 1000)) : '--'), 1)
                        ], undefined, true),
                        _: 2
                      }, 1032, ["is-highlighted", "class"]))
                    : _createCommentVNode("", true),
                  (_unref(headerList).includes('memo'))
                    ? (_openBlock(), _createBlock(EzCell, {
                        key: 24,
                        "is-highlighted": isCellHighlighted(virtualItem),
                        class: _normalizeClass(virtualItem.type === 'child' ? 'table-memo-cell table-child-item' : 'table-memo-cell')
                      }, {
                        default: _withCtx(() => [
                          (virtualItem.type === 'parent')
                            ? (_openBlock(), _createBlock(TableMemoButton, {
                                key: 0,
                                memo: item.note,
                                onSave: (memoText) => _unref(saveAggregateMemo)(memoText, item.businessId),
                                onDelete: () => _unref(deleteAggregateMemo)(item.businessId)
                              }, null, 8, ["memo", "onSave", "onDelete"]))
                            : (_openBlock(), _createBlock(TableMemoButton, {
                                key: 1,
                                memo: item.note,
                                onSave: (memoText) => _unref(saveChildMemo)(memoText, item.businessId),
                                onDelete: () => _unref(deleteChildMemo)(item.businessId)
                              }, null, 8, ["memo", "onSave", "onDelete"]))
                        ], undefined, true),
                        _: 2
                      }, 1032, ["is-highlighted", "class"]))
                    : _createCommentVNode("", true)
                ], 64))
      ]),
      row: _withCtx(({ item, virtualItem }) => [
        (virtualItem.type === 'loading' || virtualItem.type === 'zeroMatch')
          ? (_openBlock(), _createBlock(EzCell, {
              key: 0,
              "is-highlighted": ""
            }))
          : (virtualItem.type === 'error')
            ? (_openBlock(), _createBlock(EzCell, {
                key: 1,
                class: "table-row--error"
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (
              _unref(state).businessRowMenuState.editTransaction.isEditTransactionMode &&
              !(virtualItem.id == _unref(state).isOpeningBusinessId || virtualItem.parentId == _unref(state).isOpeningBusinessId)
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.transactionMonths, (month) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: month }, [
                    (virtualItem.type === 'parent' || virtualItem.type === 'child')
                      ? (_openBlock(), _createBlock(_unref(InventoryMonthlyColumn), {
                          key: 0,
                          month: month,
                          item: item,
                          "virtual-item-type": virtualItem.type,
                          "monthly-data": _unref(state).monthlyData,
                          "header-list": _unref(headerList),
                          "is-opening-business-id": _unref(state).isOpeningBusinessId,
                          "inventory-vm": _unref(inventoryVm),
                          "is-highlighted": isCellHighlighted(virtualItem),
                          "monthly-end-header": getMonthlyEndHeader.value[month],
                          "table-number-style-class": _unref(tableNumberStyleClass),
                          "get-now-inventory-status-class": _unref(getNowInventoryStatusClass),
                          "get-execution-date-formatted": getExecutionDateFormatted,
                          "is-negative": _unref(isNegative),
                          "check-nearest-recommend": _unref(checkNearestRecommend),
                          "get-arrival-status-when-display-button": _unref(getArrivalStatusWhenDisplayButton),
                          "is-edit-transaction-mode": 
                (_unref(state).isOpeningBusinessId === item.businessId || _unref(state).isOpeningBusinessId === virtualItem.parentId) &&
                _unref(state).businessRowMenuState.editTransaction.isEditTransactionMode
              ,
                          "current-month-edit-transaction-value": 
                _unref(state).businessRowMenuState.editTransaction.changedValue.filter((v) => v.month === month)
              ,
                          onUpdateEditTransactionValue: _cache[2] || (_cache[2] = (val) => updateEditTransactionValue(val))
                        }, null, 8, ["month", "item", "virtual-item-type", "monthly-data", "header-list", "is-opening-business-id", "inventory-vm", "is-highlighted", "monthly-end-header", "table-number-style-class", "get-now-inventory-status-class", "is-negative", "check-nearest-recommend", "get-arrival-status-when-display-button", "is-edit-transaction-mode", "current-month-edit-transaction-value"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128)),
                _createVNode(EzCell, {
                  "force-center": "",
                  class: "table-cell",
                  "is-highlighted": isCellHighlighted(virtualItem)
                }, {
                  default: _withCtx(() => [
                    _createVNode(BusinessRowMenu, {
                      "business-id": item.businessId,
                      "tool-tip-message": 
                _unref(state).businessRowMenuState.editTransaction.isEditTransactionMode ? _unref(t)('数値データ編集中は使用できません') : undefined
              ,
                      disabled: _unref(state).businessRowMenuState.editTransaction.isEditTransactionMode,
                      onSelect: async (e) => _unref(setBusinessRowMenuStateAndProcessing)(e, item, virtualItem.type, virtualItem.parentId)
                    }, null, 8, ["business-id", "tool-tip-message", "disabled", "onSelect"])
                  ], undefined, true),
                  _: 2
                }, 1032, ["is-highlighted"])
              ], 64))
      ]),
      loading: _withCtx(() => [
        _createVNode(EzTableLoadingState, {
          message: _unref(t)('データを読み込んでいます')
        }, null, 8, ["message"])
      ]),
      error: _withCtx(({ retry }) => [
        _createVNode(EzTableErrorState, { onRetry: retry }, null, 8, ["onRetry"])
      ]),
      "zero-match": _withCtx(() => [
        _createVNode(EzTableZeroMatchState)
      ]),
      _: 1
    }, 8, ["id", "items", "item-height", "container-height", "buffer-size", "grid-template-columns", "expanded-items", "loading-status", "sticky-column-indexes"])
  ]))
}
}

})